import script from "./SocialSecurityNumberInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./SocialSecurityNumberInput.vue?vue&type=script&setup=true&lang=ts"

import "./SocialSecurityNumberInput.vue?vue&type=style&index=0&id=68eea8de&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68eea8de"]])

export default __exports__